import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { User } from './auth.service'; // Asegúrate de que User esté exportado desde auth.service

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  
  constructor(private authService: AuthService, private router: Router) {}
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (this.authService.isLoggedIn()) {
      // Verificar permisos requeridos si están definidos en la ruta
      if (route.data && route.data['requiredPermission']) {
        const permission = route.data['requiredPermission'] as keyof User['permissions'];
        if (!this.authService.hasPermission(permission)) {
          this.router.navigate(['/dashboard']);
          return false;
        }
      }

      // Verificar roles requeridos si están definidos en la ruta
      if (route.data && route.data['requiredRole'] && route.data['requiredRole'] === 'Admin' && !this.authService.isAdmin()) {
        this.router.navigate(['/dashboard']);
        return false;
      }

      return true;
    }

    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}